module.exports = __webpack_public_path__ + "img/asset1.d8cb4268.png";